import React from 'react';

const ScreenContainer = ({ children, className = '' }) => {
  return (
    <div className={`min-h-screen flex items-center justify-center px-4 py-8 ${className}`}>
      <div className="w-full max-w-md">
        {children}
      </div>
    </div>
  );
};

export default ScreenContainer;